import { Modal, Tooltip } from 'antd'
import Button from 'components/Button/index'
import Drawer from 'components/Drawer'
import React, { useEffect, useState } from 'react'
import { createGlobalStyle } from 'styled-components'
import { EmptyElement } from '../../../../../../../components/UIComponents/CommonStyledDiv'
import CandidateViewDrawer from '../../../../ApplicantTrackingSystem/ApplicationTable/Partials/CandidateViewDrawer'
import CandidateModal from '../../CandidatesPage/Partials/CandidateModal'
import CandidateTable from '../../IndividualPage/Partials/CandidateTable/index'
import {
  QuestionWidth,
  SeeMoreDrawerContainer,
  SeeMoreHeader,
  SeeMoreHeaderRight,
  Wrapper,
} from '../../IndividualPage/Style/style'
import {
  AlertTextDivNew,
  NoteMessageSummary,
  NoteMessageSummaryNew,
  StyledSpaceDiv,
} from '../../OverViewpage/style'
import { CardsFlex } from '../../Style/style'

const GlobalStyles = createGlobalStyle`
  .ant-drawer-mask {
    background: rgb(0 0 0 / 6%) !important;
  }
  .ant-drawer-right > .ant-drawer-content-wrapper {
    top: 0;
    right: 0;
    bottom: 0;
    box-shadow: none !important;
}
.ant-drawer-wrapper-body {
  overflow: unset;
}
.ant-drawer-body{
  overflow-x: hidden;
  padding:10px 10px 30px 30px !important;
}
.ant-drawer-content {
    width: 100%;
    
    overflow: unset;
    background: #fff;
    pointer-events: auto;
}
`

const QuestionWithSeeMore = ({
  drawerVisible,
  onClose,
  labels,
  questionToDisplay,
  getIndividualDrawerList,
  individualDrawerQuestion,
  questionId,
  status,
  roleId,
  setSelectedRowKeys,
  selectedRowKeys,
  setPageNum,
  pageNum,
  singleRoleData,
  getCandidateDetails,
  getPromotion,
  getQuestionAndAnswerList,
  loading,
  setLoading,
  setClear,
  clear,
  setCountDriveSummary,
  countDriveSummary,
}) => {
  useEffect(() => {
    if (individualDrawerQuestion) {
      const newCount = individualDrawerQuestion?.result?.reduce((acc, item) => {
        if (item?.driveRoleCandidateMap?.length > 0) {
          return acc + 1
        }
        return acc
      }, 0)

      setCountDriveSummary(individualDrawerQuestion?.result?.length - newCount)
    }
  }, [individualDrawerQuestion])

  const [textNew, setTextNew] = useState(false)
  const [candidateLoading, setCandidateLoading] = useState(false)
  const [viewDrawer, setViewDrawer] = useState(false)
  const [selectedId, setSelectedId] = useState('')
  const [drawerStatus, setDrawerStatus] = useState('')
  const [candidateFilterData, setCandidateFilterData] = useState({})
  const [candidateRating, setCandidateRating] = useState({
    minValue: '',
    maxValue: '',
  })
  const [modalVisible, setModalVisible] = useState(false)
  const [questions, setQuestions] = useState([])

  const [searchValue, setSearchValue] = useState('')
  const [modalActionType, setModalActionType] = useState('') // Add this line
  const [candidateStatus, setCandidateStatus] = useState('')
  const [sortBy, setSortBy] = useState('')
  const [orderBy, setOrderBy] = useState('')

  const showModal = actionType => {
    setModalVisible(true)
    setModalActionType(actionType)
  }

  const closeModal = () => {
    setModalVisible(false)
  }
  const handleShortlistClick = () => {
    showModal('shortlist')
  }

  const handleRejectClick = () => {
    showModal('reject')
  }

  const handleSort = (page, search, filter) => {
    if (filter?.order) {
      let sort = filter?.order == 'ascend' ? 'asc' : 'desc'
      setSortBy(filter?.field)
      setOrderBy(sort)
    } else {
      setOrderBy('')
      setSortBy('')
    }
  }

  const LabelChange = label => {
    if (label == 'Correct') {
      return ' answered "Correctly" '
    } else if (label == 'Incorrect') {
      return ' answered "Incorrectly" '
    } else {
      return ' Not Answered '
    }
  }
  const onSelectChange = selectedRowKeys => {
    setSelectedRowKeys(selectedRowKeys)
    if (countDriveSummary == selectedRowKeys?.length) {
      setTextNew(false)
      setClear(false)
    } else setClear(true)
    setTextNew(false)
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    preserveSelectedRowKeys: true,
    getCheckboxProps: record => {
      return {
        disabled: record?.driveRoleCandidateMap?.length > 0,
      }
    },
    renderCell: (checked, record, index, originNode) => {
      return record?.driveRoleCandidateMap?.length > 0 ? (
        <Tooltip title="Drive is scheduled">{originNode}</Tooltip>
      ) : (
        originNode
      )
    },
  }

  const fetchCandidateData = () => {
    let search = searchValue?.trim()
    getIndividualDrawerList({
      roleId,
      status,
      questionId,
      search,
      sortBy,
      orderBy,
      pageNum,
      candidateFilterData,
      setLoading,
    })
  }
  useEffect(() => {
    fetchCandidateData()
  }, [pageNum])
  useEffect(() => {
    let getData
    setPageNum(1)
    if (searchValue) {
      getData = setTimeout(() => {
        fetchCandidateData()
      }, 500)
    } else {
      fetchCandidateData()
    }
    return () => clearTimeout(getData)
  }, [searchValue, sortBy, orderBy, candidateFilterData])
  const handleClick = (id, status) => {
    questionAndAnswer(id)

    studentDetailsAPI(id)
    getPromotion(id)
    setSelectedId(id)
    setDrawerStatus(status)
  }
  const questionAndAnswer = async studentId => {
    const { status, data } = await getQuestionAndAnswerList({
      roleId,
      studentId,
    })
    if (status >= 200 && status < 300) {
      setQuestions(data?.data)
    }
  }
  const studentDetailsAPI = async std_Id => {
    const { status } = await getCandidateDetails({
      studentId: std_Id,
      roleId,
      setLoading: setCandidateLoading,
    })

    if (status >= 200 && status < 300) {
      setViewDrawer(true)
    }
  }

  const onClickShortlist = () => {
    showModal(drawerStatus == -1 ? 'shortlist' : 'reject')
    setSelectedRowKeys([selectedId])
  }

  const handleSelectAllClick = () => {
    setTextNew(true)
  }

  const handleClearAllClick = () => {
    setTextNew(false)
    setSelectedRowKeys([])
  }

  const content = () => {
    return (
      <>
        <GlobalStyles />
        <SeeMoreDrawerContainer>
          <SeeMoreHeader>
            Candidates who’ve {LabelChange(labels)} for this question
          </SeeMoreHeader>
          <SeeMoreHeaderRight>
            <Button.Secondary
              height={'38px'}
              text={'Shortlist'}
              style={{ backgroundColor: '#3249D7', color: 'white' }}
              onClick={handleShortlistClick}
              disabled={selectedRowKeys?.length == 0}
              title={
                selectedRowKeys?.length === 0
                  ? 'Please select the candidate to shortlist'
                  : ''
              }
            />
            <Button.Secondary
              height={'38px'}
              text={'Reject'}
              style={{ backgroundColor: '#E35E50', color: 'white' }}
              onClick={handleRejectClick}
              disabled={selectedRowKeys?.length == 0}
              title={
                selectedRowKeys?.length === 0
                  ? 'Please select the candidate to reject'
                  : ''
              }
            />
          </SeeMoreHeaderRight>
        </SeeMoreDrawerContainer>

        <div
          style={{ borderBottom: '1px solid #E6E7EA', width: '102em' }}
        ></div>

        <SeeMoreHeaderRight>
          <QuestionWidth>
            <div style={{ paddingTop: '15px', paddingBottom: '15px' }}>
              {`Q${
                questionToDisplay?.questionNo
              }. ${questionToDisplay?.question?.replace(
                /<[^>]+>|\s+&nbsp;/g,
                ''
              )}`}
            </div>
            {questionToDisplay?.answer?.map((value, index) => {
              const listItem = `${String.fromCharCode(97 + index)}) ${value}`
              return (
                <div style={{ paddingTop: '15px' }} key={index + 'listItems'}>
                  {listItem}
                </div>
              )
            })}
          </QuestionWidth>

          <Wrapper>
            <CardsFlex column>
              {!clear &&
              selectedRowKeys?.length > 0 &&
              individualDrawerQuestion?.count > 10 &&
              !textNew ? (
                <>
                  <div
                    style={{
                      fontSize: '13px',
                      paddingTop: '10px',
                      paddingLeft: '12px',
                    }}
                  >
                    Selected{' '}
                    <span style={{ fontWeight: 800 }}>
                      {selectedRowKeys?.length}{' '}
                      {selectedRowKeys?.length > 1 ? 'candidates' : 'candidate'}
                    </span>{' '}
                    without scheduled drive from this page.
                  </div>
                  <NoteMessageSummary mandatory={true}>
                    <StyledSpaceDiv mandatory={true}>
                      <AlertTextDivNew mandatory={true}>
                        <EmptyElement
                          style={{
                            paddingLeft: '3px',
                            paddingRight: '3px',
                            wordSpacing: '2px',
                            cursor: 'pointer',
                          }}
                          onClick={handleSelectAllClick}
                        >
                          Select all{' '}
                          <span style={{ fontWeight: 800 }}>
                            {`${individualDrawerQuestion?.driveCountForFilter} `}
                            candidates
                          </span>{' '}
                          without scheduled drive from all pages.
                        </EmptyElement>
                      </AlertTextDivNew>
                    </StyledSpaceDiv>
                  </NoteMessageSummary>
                </>
              ) : !clear &&
                selectedRowKeys?.length > 0 &&
                individualDrawerQuestion?.count > 10 &&
                textNew ? (
                <>
                  <div
                    style={{
                      fontSize: '13px',
                      paddingTop: '10px',
                      paddingLeft: '12px',
                    }}
                  >
                    {`Selected all `}
                    <span style={{ fontWeight: 800 }}>
                      {`${individualDrawerQuestion?.driveCountForFilter}`}{' '}
                      candidates
                    </span>
                    {` without scheduled drive from all pages.`}
                  </div>
                  <NoteMessageSummaryNew mandatory={true}>
                    <StyledSpaceDiv mandatory={true}>
                      <AlertTextDivNew mandatory={true}>
                        <EmptyElement
                          style={{
                            paddingLeft: '3px',
                            paddingRight: '3px',
                            wordSpacing: '2px',
                            cursor: 'pointer',
                            fontWeight: 800,
                          }}
                          onClick={handleClearAllClick}
                        >
                          {`Clear Selection`}
                        </EmptyElement>
                      </AlertTextDivNew>
                    </StyledSpaceDiv>
                  </NoteMessageSummaryNew>{' '}
                </>
              ) : (
                ''
              )}
              <CandidateTable
                loading={loading}
                setLoading={setLoading}
                rowSelection={rowSelection}
                setCandidateRating={setCandidateRating}
                getIndividualDrawerList={getIndividualDrawerList}
                individualDrawerQuestion={individualDrawerQuestion}
                roleId={roleId}
                status={status}
                setCandidateStatus={setCandidateStatus}
                candidateStatus={candidateStatus}
                questionId={questionId}
                pageNum={pageNum}
                setPageNum={setPageNum}
                setSearchValue={setSearchValue}
                searchValue={searchValue}
                handleSort={handleSort}
                candidateRating={candidateRating}
                setCandidateFilterData={setCandidateFilterData}
                candidateFilterData={candidateFilterData}
                handleClick={handleClick}
                setClear={setClear}
                setTextNew={setTextNew}
                setSelectedRowKeys={setSelectedRowKeys}
              />
            </CardsFlex>
          </Wrapper>
        </SeeMoreHeaderRight>
      </>
    )
  }

  return (
    <>
      <Drawer
        width="60%"
        title={''}
        placement="right"
        closable={true}
        onClose={onClose}
        visible={drawerVisible}
        height="100%"
        content={content()}
        candidateLoading={candidateLoading}
      />
      <Modal
        visible={modalVisible}
        centered
        closable={false}
        footer={null}
        width={670}
        onClose={closeModal}
      >
        <CandidateModal
          onClose={closeModal}
          actionType={modalActionType}
          setSelectedRowKeys={setSelectedRowKeys}
          selectedRowKeys={selectedRowKeys}
          setPageNum={setPageNum}
          summary={true}
          getIndividualDrawerList={getIndividualDrawerList}
          roleId={roleId}
          questionId={questionId}
          status={status}
          pageNum={pageNum}
          setViewDrawer={setViewDrawer}
          setLoading={setLoading}
          setTextNew={setTextNew}
          setClear={setClear}
          textNew={textNew}
          tab={'Summary'}
          individualDrawerQuestion={individualDrawerQuestion}
          setCountDriveSummary={setCountDriveSummary}
          countDriveSummary={countDriveSummary}
        />
      </Modal>

      <CandidateViewDrawer
        candidateDrawer={viewDrawer}
        setCandidateDrawer={setViewDrawer}
        singleRoleData={singleRoleData}
        questionnaire={true}
        drawerStatus={drawerStatus}
        buttonText={
          drawerStatus == -1
            ? 'Shortlist this Candidate'
            : 'Reject this Candidate'
        }
        onClickShortlist={onClickShortlist}
        questions={questions}
      />
    </>
  )
}

export default QuestionWithSeeMore
